import getDefaultPosition from './getDefaultPosition';
export default function computeInsertPosition(items, item) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'before';

  if (direction === 'before') {
    var index = items.indexOf(item);
    var atStart = index === 0;
    var beforeItemPosition = atStart ? 0 : items[index - 1].position;
    return (beforeItemPosition + item.position) / 2;
  }

  if (direction === 'after') {
    var _index = items.indexOf(item);

    var atEnd = _index === items.length - 1;
    var afterItemPosition = atEnd ? getDefaultPosition(item.position) : items[_index + 1].position;
    return (afterItemPosition + item.position) / 2;
  }
}